/** The three review totals above the plan in Review & sign (solo and facilitated alike). Counts only; signing is never blocked by them. */
import type { ReviewTotals } from "../reviewState";
import { REVIEW_WORDS } from "../reviewWords";
import { Bar, Legend, countsLine } from "./Tracker";
import "./tracker.css";

/** Nothing left to review: "All 5 open decisions handled: 5 kept as they were" (the adjusted ones named first when there are any). */
const doneLine = (t: ReviewTotals): string => `${REVIEW_WORDS.all} ${t.total} ${REVIEW_WORDS.open} ${t.total === 1 ? REVIEW_WORDS.decision : REVIEW_WORDS.decisions} ${REVIEW_WORDS.handled}: ${t.adjusted > 0 ? `${t.adjusted} ${REVIEW_WORDS.adjusted.toLowerCase()}, ` : ""}${t.maintained} maintained`;

export function GxReviewTotals({ totals }: { readonly totals: ReviewTotals }) {
  if (totals.total === 0) return null;
  return (
    <section className="gx-trk-tot" aria-label="Decision review" data-testid="review.totals">
      <p className="gx-trk-total" data-testid="review.totals.line">{totals.toReview === 0 ? doneLine(totals) : `${countsLine(totals)} (${totals.total} ${REVIEW_WORDS.open} ${totals.total === 1 ? REVIEW_WORDS.decision : REVIEW_WORDS.decisions})`}</p>
      <Bar totals={totals} />
      <Legend totals={totals} />
    </section>
  );
}
